<template >
  <div class="mod-sendemail" style="min-height: 814px;overflow:auto;">
    <el-container>
      <el-header style="text-align: left">
        <span><h3 >发送消息</h3></span>
        <el-form
          :model="dataForm"
          :rules="rules"

          ref="dataForm"
          label-width="80px">

          <el-form-item label="消息标题"  prop="title">
            <el-input v-model="dataForm.title" placeholder="消息标题" maxlength="100"></el-input>
          </el-form-item>

          <el-form-item label="内容" prop="content">
            <el-input type="textarea"  :rows="5" v-model="dataForm.content" placeholder="内容" maxlength="5000"></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-select v-model="dataForm.type" clearable placeholder="请选择">
              <el-option
                      v-for="item in types"
                      :key="item.id"
                      :label="item.typeName"
                      :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="图片" prop="img">
            <el-upload
                    action="#"
                    :limit="3"
                    list-type="picture-card"
                    :file-list="imgList"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                    :http-request="httpRequest"
                    :before-upload="beforeAvatarUpload">
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">最多上传3张图片</div>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </el-form-item>
          <el-form-item prop="sendType" label="发送方式">
               <el-radio-group v-model="dataForm.state">
              <el-radio label="0" style="width:85px">按工号发送</el-radio>
              <el-radio label="1" style="width:85px">按部门发送</el-radio>
              <el-radio label="2" style="width:85px">筛选用户</el-radio>
              <el-radio label="3" style="width:85px">全体发送</el-radio>
               </el-radio-group>
          </el-form-item>
          <el-form-item label="工号" prop="workNumber" v-if="dataForm.state === '0'" key="email">
              <el-input v-model="dataForm.workNumber" placeholder="请输入工号，多个以，隔开"></el-input>
          </el-form-item>
          <el-form-item label="部门" prop="dept" v-if="dataForm.state === '1'" key="emails">
            <el-tree
                    :data="bmList"
                    :props="bmListTreeProps"
                    node-key="bmid"
                    ref="bmListTree"
                    :default-expand-all="true"
                    show-checkbox>
            </el-tree>
          </el-form-item>
          <el-form-item label="用户" prop="user" v-if="dataForm.state == 2" >
          <el-row>
            <el-col :span="24">
              <el-select clearable :disabled="deptdisable" @change="selectChanged2"   filterable   v-model="form.dept"  placeholder="请选择大队">
              <el-option
                      v-for="item in depts"
                      :key="item.bmid"
                      :label="item.bmmc"
                      :value="item.bmid"
                      :disabled="deptdisable">
              </el-option>
            </el-select>
              <el-select clearable :disabled="childdeptdisable" v-model="form.childDept" @change="selectChanged3"  placeholder="请选择班组" clearable>
                <el-option
                        v-for="item in childDept"
                        :key="item.bmid"
                        :label="item.bmmc"
                        :value="item.bmid"
                >
                </el-option>
              </el-select>
              <el-input @change="selectChanged3"  @keyup.enter.native="selectChanged3" placeholder="模糊查询用户名" v-model="form.name" prefix-icon="el-icon-user" clearable style="width: 20%">
              </el-input>
            </el-col>
          </el-row>
            <el-row>
              <el-table  :data="userList" ref="userTable" v-loading="loading" style="text-align: center; width: 100%;" :row-key="getRowKeys" @selection-change="selectionChangeHandle">
                <el-table-column
                        type="selection"
                        header-align="center"
                        align="center"
                        width="50"
                        :reserve-selection="true">
                </el-table-column>
                <el-table-column prop="username" label="用户编号">

                </el-table-column>
                <el-table-column prop="xm" label="用户名">
                </el-table-column>
                <el-table-column label="手机号码" prop="sjhm">
                </el-table-column>
                <el-table-column label="部门">
                  <template slot-scope="scope">
                    <span>{{getBm(scope.row)}}</span>
                  </template>
                </el-table-column>

              </el-table>
              <el-pagination background layout="total, prev, pager, next" :total="total" @current-change="pageUser" style="margin-top: 1rem;"></el-pagination>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-button  type="primary" @click="dataFormSubmit()">确定</el-button>
          </el-form-item>
        </el-form>

      </el-header>
    </el-container>
     <!-- 选择 -->
<!--    <memberselect v-if="memberSelectVisible" ref="memberselect" @dataListSelections="get" prop="dataForm.emailList"></memberselect>-->
  </div>
</template>

<script>
  import { Loading } from 'element-ui';
  export default {
    data () {

      return {
        total:0,
        userList:[],
        loading:[],
        types:[],
        form:{
          dept:'',
          childDept: '',
          name:''
        },
        getRowKeys(row) {
          return row.id;
        },
        depts:[],
        childDept:[],
        deptdisable:false,
        childdeptdisable:false,
        imgList:[],
        memberSelectVisible: false,
        tag: 0,
        dialogVisible:false,
        dialogImageUrl:'',
        bmList:[],
        dataForm: {
          limit: 0,
          content: '',
          title: '',
          state: '0',
          workNumber: '',

        },
        dataListSelections:[],
        bmListTreeProps: {
          label: 'bmmc',
          children: 'children'
        },
        arr: [],
        rules: {
          title: [
            { required: true, message: '标题不能为空', trigger: 'blur' }
          ],
          content: [
            { required: true, message: '内容不能为空', trigger: 'blur' }
          ],
          type: [
            { required: true, message: '类型不能为空', trigger: 'blur' }
          ],
          workNumber: [
            { required: true, message: '工号不能为空', trigger: 'blur' }
          ]
        },
        bmxx:[]
      }
    },
    components: {
      // memberselect
    },
    mounted() {
      this.getBmTree()
      this.getDepts()
      this.getbmxx()
      this.getTypes()
    },
    methods: {
      getTypes() {
        this.$request.get('/bjba/message/type/getAll').then(res => {

          this.types = res.data.data;
        })
      },
      selectionChangeHandle (val) {
        console.log(val)
        this.dataListSelections = val
      },
      getbmxx() {
        let that = this;
        this.$request.get('/bjba/yhgl/getbmxx').then(res => {
          console.log("bmxx:", res);
          that.bmxx = res.data;
        })
      },
      getBm(user) {
        var ubmid ;
        if(user.ddbz)  ubmid= user.ddbz;
        else ubmid = user.zzdyqc
        for(var i=0; i<this.bmxx.length;i++) {

          if(this.bmxx[i].bmid == ubmid) {
            return this.bmxx[i].bmmc
          }
        }
      },
      // 切换页码
      pageUser(page) {
        this.currentPage = page
        this.getUserList()
      },
      getDepts() {
        let that = this;
        this.$request.get('/bjba/kqtj/getFirstMentForUser',{
          params: {
            userid:this.$store.getters.username
          }

        }).then(res => {
          that.depts = res.data
          if(this.depts && this.depts[0]) {
            var zzdyqc = this.$store.getters.user.zzdyqc;
            if(zzdyqc){
              if(zzdyqc != this.CONST_ZN_BM) {
                var zw = this.$store.getters.user.zw;

                if(zw) {
                  if(zw=='01'||zw=='02'||zw=='03') {
                    this.form.dept = that.depts[0].bmid
                    this.deptdisable = true
                    if(zw !='01') {
                      this.childdeptdisable =true;
                    }
                    this.selectChanged2(this.form.dept)
                  }
                  this.selectChanged2(this.form.dept)
                } else {this.selectChanged2(this.form.dept)}
              } else {this.selectChanged2(this.form.dept)}

            } else {this.selectChanged2(this.form.dept)}
            this.selectChanged2(this.dept)

          }
        })
      },
      selectChanged2(value) {
        this.currentPage = 1
        this.childDept = []
        this.form.childDept =''
        this.$request({
          method: 'get',
          url: '/bjba/kqtj/getMentForUser2',
          params: {
            fbmid: value,
            userid:this.$store.getters.username
          }
        }).then((response) => {

          this.childDept = response.data;
          var zzdyqc = this.$store.getters.user.zzdyqc;
          if(zzdyqc){
            if(zzdyqc != this.CONST_ZN_BM) {
              var zw = this.$store.getters.user.zw;

              if(zw) {
                if(zw=='02'||zw=='03') {
                  if(this.childDept[0]) {
                    this.form.childDept = this.childDept[0].bmid

                  }
                }
              }
            }

          }

          this.getUserList();
        }).catch((err) => {
          console.log(err)
        })
      },
      selectChanged3(value) {
        this.currentPage = 1;
          this.getUserList();


      },
      getUserList: function () {
        this.loading = true
        const {
          username,
          currentPage
        } = this
        this.form.page = this.currentPage;
        this.form.pagesize = 10
        this.form.userid = this.$store.getters.username
        this.$request.get('/bjba/yhgl/getUserList', {
          params: this.form
        }).then(res => {
          const {
            data
          } = res
          console.log("列表数据：", data)
          this.userList = data.data
          this.total = data.total

          console.log(this.userList);
          //this.total = data.totalElements
          this.loading = false
        }).catch(err => {
          this.$message({
            message: '获取用户列表出现异常!',
            type: 'error',
            center: true,
            showClose: true
          })
          this.loading = false
          console.log(err)
        })
      },
      beforeAvatarUpload(file){

        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!')
        }
        return  isLt2M;
      },
      httpRequest(data){
        let _that=this;
        let rd = new FileReader(); // 创建文件读取对象
        let file = data.file;
        rd.readAsDataURL(file); // 文件读取装换为base64类型
        rd.onloadend = function (e) {
          _that.imgList.push({
            url:e.currentTarget.result,
            name:''
          })
        }
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
        var a=0;
        for( var i=0; i<this.imgList.length;i++ ) {
          if(this.imgList[i].uid ==file.uid) {
            a =i;
            break;
          }
        }
        this.imgList.splice(i,1)


      },
      handlePictureCardPreview(file) {
        console.log(file)
        this.dialogVisible = true;
        this.dialogImageUrl = file.url;
      },
      getBmTree() {
        this.$http({
          url: '/bjba/bmxx/getAllMyBm',
          method: 'get'
        }).then(({data}) => {
          this.bmList = this.treeDataTranslate(data.data, 'bmid',"fbmid")
        })
      },
      remove (index) {
        this.dataForm.emailList.splice(index, 1)
      },
      get (msg) {
        for (var a = 0; a < msg.length; a++) {
          this.dataForm.emailList.push(msg[a])
        }
        for (var i = 0; i < this.dataForm.emailList.length; i++) { // 循环遍历当前数组
          // 判断当前数组下标为i的元素是否已经保存到临时数组
          // 如果已保存，则跳过，否则将此元素保存到临时数组中
          for (var j = 0; j < this.arr.length; j++) {
            if (this.arr[j].membId === this.dataForm.emailList[i].membId) {
              this.tag = 1
            }
          }
          if (this.tag === 0) {
            this.arr.push(this.dataForm.emailList[i])
          } else {
            this.tag = 0
          }
        }
        this.dataForm.emailList.splice(0, this.dataForm.emailList.length)
        for (var c = 0; c < this.arr.length; c++) {
          this.dataForm.emailList.push(this.arr[c])
        }
      },
      // 选择窗口
      memberselect () {
        this.memberSelectVisible = true
        this.$nextTick(() => {
          this.$refs.memberselect.getDataList()
        })
      },
      // 表单提交
      dataFormSubmit () {

        this.$refs['dataForm']
          .validate((valid) => {
            if (valid) {
              let data ={};
              data.subject = this.dataForm.title;
              data.content = this.dataForm.content;
              data.typeId = this.dataForm.type;

              data.type = this.dataForm.state;
              data.imgList = this.imgList.map(item => {
                return item.url
              })

              if(this.dataForm.state=='0' ){
                data.workNumbers = this.dataForm.workNumber;
              } else if(this.dataForm.state == '1') {
                data.bmids = [].concat(this.$refs.bmListTree.getCheckedKeys())
                if(!data.bmids || data.bmids.length==0) {
                  this.$message.error('请选择部门');
                  return
                }
              } else if(this.dataForm.state == '2') {
                data.userids = this.dataListSelections.map(item => {
                  return item.id
                })
                if(!data.userids || data.userids.length==0) {
                  this.$message.error('请选择用户');
                  return
                }
              }
              let loadingInstance1 = Loading.service({ fullscreen: true });
              this.$http({
                url: `/bjba/message/sendMessage`,
                method: 'post',
                dataType: JSON,
                data: data
              }).then(({data}) => {
                loadingInstance1.close()
                if (data && data.code === 200) {
                  this.$message({
                    message: '发送成功',
                    type: 'success',
                    duration: 1500
                  })
                  console.log(this.dataForm.state)
                  if(this.dataForm.state =='0') {
                    this.dataForm.workNumber=''
                  }
                  if(this.dataForm.state =='1') {
                    this.$refs.bmListTree.setCheckedKeys([]);
                  }
              if(this.dataForm.state =='2') {
                this.$refs.userTable.clearSelection();
                this.dataListSelections=[];
              }

                }else {
                  this.$message({
                    message: data.message,
                    type: 'error',
                    duration: 3000
                  })
                }
              })
            }
          })
      },
      /**
       * 树形数据转换
       * @param {*} data list数据
       * @param {*} id 主键ID
       * @param {*} pid 上级ID
       * @param childrenKey 子list数据的key
       */
      treeDataTranslate (data, id = 'id', pid = 'parentId', childrenKey = 'children') {
        let res = []
        let temp = {}
        for (let i = 0; i < data.length; i++) {
          temp[data[i][id]] = data[i]
        }
        for (let k = 0; k < data.length; k++) {
          if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
            if (!temp[data[k][pid]][childrenKey]) {
              temp[data[k][pid]][childrenKey] = []
            }
            if (!temp[data[k][pid]]['_level']) {
              temp[data[k][pid]]['_level'] = 1
            }
            data[k]['_level'] = temp[data[k][pid]]._level + 1
            temp[data[k][pid]][childrenKey].push(data[k])
          } else {
            res.push(data[k])
          }
        }
        return res
      }
    }
  }
</script>
